(function () {
  if (window.KlaviyoHelpers) return;

  function onKlaviyoReady(cb) {
    if (
      window.KlaviyoSubscribe &&
      typeof window.KlaviyoSubscribe.attachToForms === "function"
    ) {
      cb();
    } else {
      var intv = setInterval(function () {
        if (
          window.KlaviyoSubscribe &&
          typeof window.KlaviyoSubscribe.attachToForms === "function"
        ) {
          clearInterval(intv);
          cb();
        }
      }, 50);
      setTimeout(function () {
        clearInterval(intv);
      }, 5000);
    }
  }

  function defaultSyncHidden(root, radiosSelector, hiddenSelector) {
    var hidden = root.querySelector(hiddenSelector);
    if (!hidden) return;
    var checked = root.querySelector(radiosSelector + ":checked");
    if (checked) hidden.value = checked.value;
  }

  function attachLegacyForm(opts) {
    var root = opts.root || document;
    var form =
      typeof opts.form === "string" ? root.querySelector(opts.form) : opts.form;
    if (!form) return;
    var radiosSelector = opts.radiosSelector || 'input[type="checkbox"]';
    var hiddenSelector = opts.hiddenSelector || 'input[name="g"]';
    var source = opts.source || "Custom Form";
    var messageSelector = opts.messageSelector || form.getAttribute('data-message-selector');
    var successText = opts.successText || form.getAttribute('data-success-text') || 'Thanks for subscribing!';
    var errorText = opts.errorText || form.getAttribute('data-error-text') || 'Something went wrong. Please try again.';
    var messageEl = messageSelector ? root.querySelector(messageSelector) : null;

    // Ensure we have a message element; if not, create one after the form
    if (!messageEl) {
      try {
        messageEl = document.createElement('div');
        messageEl.className = 'm-argyle__msg';
        messageEl.setAttribute('aria-live', 'polite');
        form.parentNode.insertBefore(messageEl, form.nextSibling);
      } catch(_) {}
    }

    function showMessage(txt, isError){
      if (!messageEl) return;
      messageEl.textContent = txt;
      messageEl.classList.remove('m-argyle__msg--success','m-argyle__msg--error');
      messageEl.classList.add(isError ? 'm-argyle__msg--error' : 'm-argyle__msg--success');
      messageEl.style.display = 'block';
    }

    // Mirror Klaviyo's own message nodes into our container (robust fallback)
    try {
      function extractAndShowExternalMsg(){
        try {
          var container = form.parentNode || document;
          // Check inside form first, then around it
          var km = form.querySelector('.klaviyo_messages') || container.querySelector('.klaviyo_messages') || form.previousElementSibling;
          if (km && km.classList && km.classList.contains('klaviyo_messages') && km.textContent.trim()) {
            var t = km.textContent.trim();
            var isErr = /error|does not exist|invalid|already/i.test(t);
            showMessage(t, isErr);
          }
        } catch(_) {}
      }
      var mo = new MutationObserver(extractAndShowExternalMsg);
      mo.observe(form.parentNode || document, { childList: true, subtree: true, characterData: true });
      // Also run once after attach
      setTimeout(extractAndShowExternalMsg, 800);
    } catch(_) {}

    function getSelectedTopics(){
      var set = new Set();
      try {
        root.querySelectorAll(radiosSelector + ':checked').forEach(function(el){
          if (el && typeof el.value === 'string') {
            var v = (el.value || '').trim();
            if (v) set.add(v);
          }
        });
      } catch(_) {}
      return Array.from(set);
    }

    function sync() {
      try {
        if (typeof opts.syncHiddenFn === 'function') {
          (opts.syncHiddenFn)(root, radiosSelector, hiddenSelector);
        }
      } catch(_) {}
    }

    // initial sync and keep in sync on radio change
    try {
      root.querySelectorAll(radiosSelector).forEach(function (r) {
        r.addEventListener("change", sync);
      });
    } catch (_) {}
    sync();

    onKlaviyoReady(function () {
      if (form.dataset.klaviyoAttached === "true") return;
      try {
        var pending = false;
        var settled = false;
        function markPending(){ pending = true; settled = false; }
        function markSuccess(){ settled = true; pending = false; }
        function markError(){ settled = true; pending = false; }
        // fallback if provider never calls our callbacks
        form.addEventListener('submit', function(){
          markPending();
          try { if (window._klaviyoCfg) { /* noop */ } } catch(_){ }
          try { if (cfg && cfg.extra_properties) { cfg.extra_properties.newsletter_topic = getSelectedTopics(); } } catch(_){ }
          setTimeout(function(){
            if (pending && !settled && messageEl){
              messageEl.textContent = errorText;
              messageEl.classList.remove('m-argyle__msg--success');
              messageEl.classList.add('m-argyle__msg--error');
            }
          }, 1200);
        }, { capture: true });

        var cfg = {
          hide_form_on_success: true,
          extra_properties: { $source: source, newsletter_topic: getSelectedTopics() },
          success: function(){
            markSuccess();
            showMessage(successText, false);
            try {
              var emailInput = form.querySelector('input[type="email"]');
              if (emailInput) emailInput.value = '';
            } catch(_) {}
          },
          error: function(){
            markError();
            // Try to surface Klaviyo's first error arg; fallback to provided errorText
            var txt = errorText;
            try {
              if (arguments && arguments[0] && Array.isArray(arguments[0])) {
                txt = arguments[0][0] || errorText;
              }
            } catch(_) {}
            showMessage(txt, true);
          }
        };

        try {
          // keep topics in sync on choice changes
          root.querySelectorAll(radiosSelector).forEach(function (r) {
            r.addEventListener('change', function(){
              try { cfg.extra_properties.newsletter_topic = getSelectedTopics(); } catch(_){ }
            });
          });
        } catch(_) {}

        window.KlaviyoSubscribe.attachToForms("#" + form.id, cfg);
        form.dataset.klaviyoAttached = "true";
      } catch (e) {}
    });

    // Defensive: if not attached yet, prevent hard redirect once
    form.addEventListener(
      "submit",
      function (e) {
        if (form.dataset.klaviyoAttached === "true") return; // allow
        e.preventDefault();
        sync();
        onKlaviyoReady(function () {
          try {
            if (form.dataset.klaviyoAttached !== "true") {
              var pending2 = false;
              var settled2 = false;
              function markPending2(){ pending2 = true; settled2 = false; }
              function markSuccess2(){ settled2 = true; pending2 = false; }
              function markError2(){ settled2 = true; pending2 = false; }
              form.addEventListener('submit', function(){
                markPending2();
                try { if (cfg2 && cfg2.extra_properties) { cfg2.extra_properties.newsletter_topic = getSelectedTopics(); } } catch(_){ }
                setTimeout(function(){
                  if (pending2 && !settled2 && messageEl){
                    messageEl.textContent = errorText;
                    messageEl.classList.remove('m-argyle__msg--success');
                    messageEl.classList.add('m-argyle__msg--error');
                  }
                }, 1200);
              }, { capture: true, once: true });

              var cfg2 = {
                hide_form_on_success: true,
                extra_properties: { $source: source, newsletter_topic: getSelectedTopics() },
                success: function(){
                  markSuccess2();
                  showMessage(successText, false);
                },
                error: function(){
                  markError2();
                  var txt = errorText;
                  try {
                    if (arguments && arguments[0] && Array.isArray(arguments[0])) {
                      txt = arguments[0][0] || errorText;
                    }
                  } catch(_) {}
                  showMessage(txt, true);
                }
              };
              window.KlaviyoSubscribe.attachToForms("#" + form.id, cfg2);
              form.dataset.klaviyoAttached = "true";
            }
          } catch (_) {}
          try {
            form.dispatchEvent(new Event("submit", { cancelable: true }));
          } catch (_) {}
        });
      },
      { once: true }
    );
  }

  function autoAttach(container) {
    var root = container || document;
    root
      .querySelectorAll('form[data-klaviyo-legacy="pending"]')
      .forEach(function (form) {
        var section = form.closest('section, custom-popup') || form.parentElement || root;
        attachLegacyForm({
          root: section,
          form: "#" + form.id,
          radiosSelector: 'input[type="checkbox"][name^="newsletter_topic_"]',
          hiddenSelector: 'input[name="g"]',
          syncHiddenFn: function(){ /* no-op: we now use a master list ID */ },
          source: form.getAttribute("data-klaviyo-source") || "Custom Form",
        });
      });
  }

  window.KlaviyoHelpers = {
    onKlaviyoReady: onKlaviyoReady,
    attachLegacyForm: attachLegacyForm,
    autoAttach: autoAttach,
  };

  autoAttach(document);

  document.addEventListener("DOMContentLoaded", function () {
    autoAttach(document);
  });
  document.addEventListener("shopify:section:load", function (e) {
    autoAttach(e.target);
  });
  document.addEventListener("shopify:section:select", function (e) {
    autoAttach(e.target);
  });
})();

